<script>
import $ from "jquery";

export default {
  mounted() {
    $(document).ready(function () {
        //AZS-473
        var alltitles = document.querySelectorAll('svg title');

        // Parcourez chaque balise <title> et supprimez-la
            alltitles.forEach(function(onetitle) {
            onetitle.remove();
        });
      window.dataLayer = window.dataLayer || [];
      let itemToPush = {};
      let H1 = jQuery('h1');
      if (H1.length) {
        itemToPush['pagename'] = H1.text().replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      } else{
        let windowPath = window.location.pathname;
        let updatedPath = windowPath.replace(/["+?!/]/g,'')
                    .replace(/[#_', ]/g,'_')
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "");

        itemToPush['pagename'] = updatedPath;
      }

      itemToPush['pagetype'] = 'faq';
      itemToPush['event'] = "page_load";
      window.dataLayer.push(itemToPush);
    });
  },
}
</script>
